const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT; 

async function get(url) {
  try {
    var response = await fetch(API_ENDPOINT + url);
    if (!response.ok) {
      throw Error(response.statusText);
    }
    response = await response.json();
    return response;
  } catch (err) {
    console.error(err);
    throw Error(err);
  }
}

async function post(url, body = null) {
  try {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: body != null ? JSON.stringify(body) : "",
    };
    var response = await fetch(API_ENDPOINT + url, requestOptions);
    if (!response.ok) {
      throw Error(response.statusText);
    }
    response = await response.json();
    return response;
  } catch (err) {
    console.error(err);
    throw Error(err);
  }
}

async function put(url, body = null) {
  try {
    const requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: body != null ? JSON.stringify(body) : "",
    };
    var response = await fetch(API_ENDPOINT + url, requestOptions);
    if (!response.ok) {
      throw Error(response.statusText);
    }
    response = await response.json();
    return response;
  } catch (err) {
    console.error(err);
    throw Error(err);
  }
}

export async function fetchCompanyProfile(companyProfileId, attendeeId) {
  return get(
    `/event/companyprofile/getCompanyProfileUserView?companyprofileid=${companyProfileId}&attendeeID=${+attendeeId}&includeMemberCompanies=true`
  );
}

export async function fetchCurrentReception(
  companyProfileId,
  eventId,
  isReceptionist = false, 
) {
  return get(
    `/event/companyprofile/getcurrentreception?companyProfileID=${companyProfileId}&eventid=${eventId}&isreceptionist=${isReceptionist}`
  );
}

export async function fetchMeetingDetails(personalEventId) {
  return get(
    `/event/personalevents/single/${personalEventId}`
  );
}

export async function fetchUserMeetings(orderId) {
  return get(`/event/personalevents/singleorder/${orderId}?withdetails=1`);
}

export async function fetchUserProfile(userId, pubId, eventId) {
  return get(
    `/profile?GetIds_userid=${userId}&pubid=${pubId}&eventid=${eventId}`
  );
}

export async function fetchAllEvents(
  companyProfileId,
  attendeeId,
  eventId,
  isReceptionist = false
) {
  return get(
    `/event/companyprofile/getHostPersonalEvents/${companyProfileId}?attendeeID=${+attendeeId}&eventid=${eventId}&isreceptionist=${isReceptionist}`
  );
}

export async function addVisitorReception(receptionId, attendeeId) {
  return post("/event/companyprofile/addvisitortoreception", {
    ReceptionID: receptionId,
    AttendeeID: attendeeId,
  });
}

export async function updateMeetingRating(personalEventId, rating) {
  return put(
    `/event/personalevents/updatemeetingrating/${personalEventId}?rating=${rating}`
  );
}

export async function updateMeetingNotes(personalEventId, notes) {
  return put(`/event/personalevents/updatemeetingrating/${personalEventId}`, {
    notes: notes,
  });
}

export async function openCloseMeeting(personalEventId, isOpen) {
  return put(
    `/event/personalevents/openclosemeeting/${personalEventId}?open=${isOpen}`
  );
}

export async function meetingAndReceptionDetails(companyProfileId, eventId, meetingId) {
  var meetingParameter = meetingId ? `&meetingID=${meetingId}` : "";
  return get(
    `/event/companyprofile/GetMeetingAndReceptionDetails/${companyProfileId}?eventid=${eventId}${meetingParameter}`
  );
}

export async function updateHostAvailability(
  companyProfileId,
  profileId,
  isAvailable
) {
  return put(
    `/event/companyprofile/updatehostavailability?companyProfileID=${companyProfileId}&profileID=${profileId}&available=${isAvailable}`
  );
}

export async function saveMeetingRating(personalEventId, params) {
  if (!params.CompanyProfileID) {
    throw new Error('Required parameter "CompanyProfileID" missing.');
  }

  if (!params.AttendeeID) {
    throw new Error('Required parameter "AttendeeID" missing.');
  }

  if (!params.EventID) {
    throw new Error('Required parameter "EventID" missing.');
  }

  return post(
    `/event/personalevents/savemeetingrating/${personalEventId}`,
    params
  );
}

/**
 * If the user represented by attendeeid is not a participant in the meeting or is
 * not an Admin for the company, the request is denied.
 * Guest:
 * - if meeting is open, guest is added to meeting attendee list and removed from
 * reception attendee list; otherwise, nothing happens
 *
 * Team member/Admin:
 * - meeting will be opened if not already opened
 * - team member/admin is added to meeting attendee list
 */
export async function addAttendeeToMeeting(meetingId, attendeeId, eventId) {
  return get(
    `/event/companyprofile/MeetingParticipantArrivesAtMeeting/${meetingId}?attendeeid=${attendeeId}&eventid=${eventId}`
  );
}

export async function getControlRoomDetails(
  companyProfileId,
  attendeeId,
  eventId
) {
  return get(
    `/event/companyprofile/GetTeamMemberControlRoomDetails/${companyProfileId}?attendeeid=${attendeeId}&eventid=${eventId}`
  );
}

export async function guestArrivesAtReception(
  companyProfileId,
  attendeeId,
  meetingId,
  eventId
) {
  var meetingParameter = meetingId ? `&meetingid=${meetingId}` : "";
  return get(
    `/event/companyprofile/GuestArrivesAtReception/${companyProfileId}?attendeeid=${attendeeId}${meetingParameter}&eventid=${eventId}`
  );
}

export async function getControlPanelDetails(companyProfileId, attendeeId, eventId) {
  return get(
    `/event/companyprofile/MeetingParticipantArrivesAtMeeting/${companyProfileId}?attendeeid=${attendeeId}&eventid=${eventId}`
  );
}
